import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

export const BaseForm = createFormHook({
  fieldComponents: {},
  formComponents: {},
  fieldContext,
  formContext
});

export { useFieldContext, useFormContext };
